import React from 'react';

export const Description = () => {
    return (
            <p className="text-center description-text">
                It's no secret that women are a minority in tech. As we work diligently to rewrite
                the narrative, it's important that we stay connected to each other. When you're a part of a community it's easier to relate, vent, and feel seen. When your workplace doesn't offer this, your community can and will.
            </p>
    )
}